export default "__VITE_ASSET__GdNG75Kq__"